<mat-accordion class="main-menu" displayMode="flat" multi=true>
  <div *ngFor="let item of items" class="menu-item">
    <mat-expansion-panel [ngClass]="{'recently-used': item.isRecentlyUsed}"
            [expanded]="isActive(item.label) || (item.isRecentlyUsed && recentlyUsedService.getAllRecentlyOpened().length > 0)"
                         *ngIf="(item.items && item.items.length > 0) || (item.isRecentlyUsed && recentlyUsedService.getAllRecentlyOpened().length > 0); else elseBlock">
      <mat-expansion-panel-header [ngClass]="{'menu-active': isActiveItem(item.label)}">
        <mat-panel-title>
          <i class="material-icons">{{item.icon}}</i>
          {{item.label | translate}}
        </mat-panel-title>
      </mat-expansion-panel-header>
        <mx-navigation-menu-items *ngIf="!item.isRecentlyUsed; else bookmarks" [menuItemPath]="menuItemPath + '/' + item.label" [items]="item.items"
                                  [activeMenuPath]="activeMenuPath">
        </mx-navigation-menu-items>
      <ng-template #bookmarks>
        <div class="dynamic-item"
             (click)="goToBreadcrumbLink(breadcrumb)" *ngFor="let breadcrumb of getRecentlyOpened()">
          <i class="material-icons" [matTooltip]="breadcrumb.tooltip | translate"
             matTooltipShowDelay="300">{{breadcrumb.icon}}</i>
          <span class="link-item-text">{{breadcrumb.title | translate}}</span>
          <i class="material-icons recently-opened-icons icon-bookmark not-pinned" *ngIf="!isPinned(breadcrumb)"
             (click)="$event.stopPropagation();pin(breadcrumb)" matTooltip="Pin"
             matTooltipShowDelay="300">push_pin</i>
          <i class="material-icons recently-opened-icons" *ngIf="isPinned(breadcrumb)" matTooltip="Pinned"
             matTooltipShowDelay="300">push_pin</i>
          <i class="material-icons recently-opened-icons icon-bookmark" (click)="$event.stopPropagation();removeRecentlyOpened(breadcrumb)" matTooltip="Remove"
             matTooltipShowDelay="300">close</i>
        </div>
      </ng-template>
    </mat-expansion-panel>
    <ng-template #elseBlock>
      <div class="link-item" *ngIf="!item.isRecentlyUsed" (click)="goTo(item)" [ngClass]="{'menu-active': isActiveItem(item.link.slice(1))}">
        <i class="material-icons">{{item.icon}}</i>
        <span class="link-item-text">{{(item.label | mxTranslate)()}}</span>
      </div>
      <div class="dynamic-item breadcrumb-item" [style.margin-left]="(index + 1) * 10 + 'px'" (click)="goToBreadcrumbLink(breadcrumb)" *ngFor="let breadcrumb of getBreadCrumbs(item) | async; let index = index">
        <i class="material-icons"
           [matTooltip]="((breadcrumb.type.replace('_', ' ') | titlecase) + ' ' + breadcrumb.title) | translate" matTooltipShowDelay="300">{{breadcrumb.icon}}</i>
        <span class="link-item-text">{{breadcrumb.title | translate}}</span>
      </div>
    </ng-template>
  </div>
</mat-accordion>
